import {
  ajaxErrorAlert,
  ajaxPost,
  parceAjaxErrorResponse,
  toggleBetweenElements,
} from "./utils";
import { bsModal, bsToast } from "./plugins";
import { ErrorSwal, getJsContext, initPlugins, SuccessSwal } from "../app";
import lo from "datatables.net-plugins/i18n/lo.mjs";

const body = $("body");

if (body.hasClass("travel")) {
  const toggleSelectOptions = (select, options) => {
    select.find("option").each(function (_, option) {
      if (options.includes($(option).val())) {
        $(option).removeAttr("disabled");
      } else {
        $(option).attr("disabled", "true");
      }
    });
    if (!options.includes(select.val())) {
      select.val("");
      select.trigger("change");
    }
  };

  const setBirthDateInputsNumber = () => {
    $(".birthDateInputWrapper .birthDateInput").each(function (index, input) {
      $(input)
        .find(".travelerNumber")
        .text(index + 1);
    });
  };

  const tripTypeSelect = $("select[name=trip_type]");
  const coverageArea = $("select[name=coverage_area]");
  const insuranceAmountSelect = $("select[name=insurance_amount]");
  const currencySelect = $("select[name=currency]");

  const setTravelStepperStep = (stepNumber = 1, animate = true) => {
    const travelStepper = $(".travel.steps");
    const totalSteps = travelStepper.find(".step");
    const totalStepsCount = totalSteps.length;
    const stepAnimation = travelStepper.find(".step-animation");
    const currentStep = travelStepper.find(".step.current");
    let currentStepNumber = currentStep.index();
    const animationDelay = 4000;
    const stepWidth = totalSteps.first().width();

    if (!stepNumber) {
      stepNumber = currentStepNumber = 1;
    }

    totalSteps.removeClass("passed").removeClass("current");
    for (let i = 1; i <= totalStepsCount; i++) {
      totalSteps.each((index, step) => {
        if (index < stepNumber - 1) {
          $(step).addClass("passed");
        } else if (index === stepNumber - 1) {
          $(step).addClass("current");
        }
      });
    }

    stepAnimation.css("left", stepWidth * (stepNumber - 1));
    if (animate) {
      stepAnimation.css("transition-duration", animationDelay + "ms");
    }

    // previous step. animation direction change
    if (currentStepNumber > stepNumber) {
      stepAnimation.addClass("reverse");
      setTimeout(() => {
        stepAnimation.removeClass("reverse");
      }, animationDelay);
    }

    // last step
    if (totalStepsCount === stepNumber) {
      setTimeout(() => {
        travelStepper.addClass("finished");
        // travelStepper
        //   .find(".plane")
        //   .get(0)
        //   .style.setProperty("--w", `${stepWidth}px`);
      }, animationDelay);
    }
  };
  const travelStepsCurrentStep = $('input[name="travelStepsCurrentStep"]');
  if (travelStepsCurrentStep) {
    setTravelStepperStep(parseInt(travelStepsCurrentStep.val()), false);
  }

  tripTypeSelect.on("change", function () {
    const tripType = $(this).val();
    const tripTypeOneTripField = $(".tripTypeOneTripField");
    const tripTypeMultiTripField = $(".tripTypeMultiTripField");

    if (tripType === "ONE_TRIP") {
      tripTypeOneTripField.show();
      tripTypeOneTripField.find("input").attr("required", "required");
      tripTypeMultiTripField.hide();
      tripTypeMultiTripField.find("select").removeAttr("required");
    } else {
      tripTypeMultiTripField.show();
      tripTypeMultiTripField.find("select").attr("required", "required");
      tripTypeOneTripField.hide();
      tripTypeOneTripField.find("input").removeAttr("required");
    }
  });

  coverageArea.on("change", function () {
    const select = $(this);
    const currencies = select
      .find("option:selected")
      .data("currencies")
      .split(",");
    const insurance_amounts = select
      .find("option:selected")
      .data("insurance-amounts")
      .split(",");

    toggleSelectOptions(insuranceAmountSelect, insurance_amounts);
    toggleSelectOptions(currencySelect, currencies);

    // if not Turkey, disable id card option on travelers
    if (select.val() !== "3") {
      $(".traveler_document_type option[value=ID]").attr("disabled", true);
    } else {
      $(".traveler_document_type option[value=ID]").removeAttr("disabled");
    }
  });

  const travelCalculationForm = $("#travelCalculationForm"),
    travelInsuredPersonForm = $("#travelInsuredPersonForm"),
    travelTravelersForm = $("#travelTravelersForm"),
    travelVerifyDataForm = $("#travelVerifyDataForm"),
    travelPaymentForm = $("#travelPaymentForm"),
    checkPaymentForm = $("#checkPaymentForm"),
    travelPolicyForm = $("#travelPolicyForm");

  $(document).on("click", ".deleteBirthDateInput", (e) => {
    const parent = $(e.target).closest(".birthDateInput");
    parent.remove();
    const birthDateInputsCount = $(".birthDateInputWrapper").find(
      ".birthDateInput",
    ).length;
    $("input[name=travelers_count]").val(birthDateInputsCount);
    setBirthDateInputsNumber();
  });

  $("input[name=travelers_count]").on("change", function (e) {
    const input = $(e.target);
    let newTravelersCount = parseInt(input.val()) || 1;
    if (newTravelersCount > input.attr("max")) {
      input.val(input.attr("max"));
      newTravelersCount = input.attr("max");
    }
    const birthDateInputWrapper = $(".birthDateInputWrapper");
    const oldTravelersCount =
      birthDateInputWrapper.find(".birthDateInput").length;
    const birthDateInput = $(".birthDateInput").first();

    if (newTravelersCount > oldTravelersCount) {
      for (let i = 0; i < newTravelersCount - oldTravelersCount; i++) {
        const newBirthDateInputWrapper = birthDateInput.clone();
        if (newBirthDateInputWrapper.find("input").length > 1) {
          // flatpickr on mobile devices creates two inputs
          newBirthDateInputWrapper.find("input")[1].remove();
        }
        newBirthDateInputWrapper.find("input").val("");
        newBirthDateInputWrapper
          .find(".deleteBirthDateInput")
          .removeClass("d-none");
        newBirthDateInputWrapper
          .find("input.form-control")
          .removeClass("rounded-end");
        birthDateInputWrapper.append(newBirthDateInputWrapper);
      }
    } else if (newTravelersCount < oldTravelersCount && newTravelersCount > 0) {
      for (let i = 0; i < oldTravelersCount - newTravelersCount; i++) {
        birthDateInputWrapper.find(".birthDateInput").last().remove();
      }
    } else {
      console.warn("Invalid travelers count");
      input.val(oldTravelersCount);
    }

    setBirthDateInputsNumber();

    $(birthDateInputWrapper.find(".form-control-datepicker")).flatpickr({
      dateFormat: "d.m.Y",
      allowInput: true,
      time_24hr: true,
    });
  });

  $("input[name=extra_coverages]").on("change", function (e) {
    const input = $(e.target);
    const extraCoverageSlug = input.data("slug");

    if (extraCoverageSlug === "alpine_skiing") {
      $('input[name=extra_coverages][data-slug="high_risk_work"]').prop(
        "checked",
        false,
      );
    } else if (extraCoverageSlug === "high_risk_work") {
      $('input[name=extra_coverages][data-slug="alpine_skiing"]').prop(
        "checked",
        false,
      );
    }
  });

  travelCalculationForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "calculate_premium",
    });
    form.loading({
      loadingText: getJsContext("calculation_loading_text"),
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        const premium = response["premium"],
          premium_azn = response["premium_azn"],
          franchise = response["franchise"].toFixed(2),
          currency = response["currency"];

        const insurance_amount = form
            .find("select[name=insurance_amount]")
            .val(),
          travelers_count = form.find("input[name=travelers_count]").val();

        $(".traveler_count_text").text(travelers_count);
        addTravelerForm(travelers_count);

        $(".premium_text").text(premium);
        $(".premium_azn_text").text(premium_azn);
        $(".currency_text").text(currency);
        $(".franchise_value").val(franchise);
        $(".insurance_amount_value")
          .val(insurance_amount)
          .select2({
            minimumResultsForSearch: -1,
          })
          .on("select2:open", function () {
            $(".select2-dropdown").hide();
            setTimeout(function () {
              $(".select2-dropdown").addClass("select2-animate-open").show();
            });
          });
        $(".currency_value").val(currency);

        travelInsuredPersonForm.loading({ action: "hide" });
        toggleBetweenElements(travelCalculationForm, travelInsuredPersonForm);
        setTravelStepperStep(2);
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          400,
        );
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  $("select[name=insurance_amount_2]").on("change", function (e) {
    e.preventDefault();
    const select = $(e.target);
    travelInsuredPersonForm.loading({
      loadingText: getJsContext("calculation_loading_text"),
      action: "show",
      extraClasses: "spinner-fixed",
    });
    $("select[name=insurance_amount]").val(select.val()).trigger("change");
    travelCalculationForm.trigger("submit");
  });

  travelInsuredPersonForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "validate_insured_person",
    });
    form.loading({
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then(() => {
        travelTravelersForm.loading({ action: "hide" });
        toggleBetweenElements(travelInsuredPersonForm, travelTravelersForm);
        setTravelStepperStep(3);
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          400,
        );

        if ($('input[name="insured_person_also_traveler"]').prop("checked")) {
          const insured_person_pin = $("input[name=insured_person_pin]").val(),
            insured_person_birth_date = $(
              "input[name=insured_person_birth_date]",
            ).val(),
            insured_person_name = $("input[name=insured_person_name]").val(),
            insured_person_surname = $(
              "input[name=insured_person_surname]",
            ).val();

          $(`input[name=traveler-0-traveler_pin]`).val(insured_person_pin);
          $(`input[name=traveler-0-traveler_name]`).val(insured_person_surname);
          $(`input[name=traveler-0-traveler_surname]`).val(insured_person_name);
          $(`input[name=traveler-0-traveler_birth_date]`).val(
            insured_person_birth_date,
          );
        }
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  const reIndexTravelers = () => {
    const travelers = $(".travelers");
    travelers.find(".traveler").each((index, traveler) => {
      $(traveler)
        .find("input, select")
        .each((_, formControl) => {
          const fieldName = $(formControl).data("field-name");
          const inputIndexedName = `traveler-${index}-${fieldName}`;
          $(formControl).attr("name", inputIndexedName);
          $(formControl).attr("id", inputIndexedName);
          $(formControl).parent().find("label").attr("for", inputIndexedName);
        });
    });
    travelers
      .find("input[name=traveler-TOTAL_FORMS]")
      .val(travelers.find(".traveler").length);

    initPlugins(travelers);
  };

  const addTravelerForm = (count = 1) => {
    const travelers = $(".travelers");
    travelers.find("select").select2("destroy");
    const currentTravelersCount = travelers.find(".traveler").length;

    const template = travelers.find(".traveler").first().clone();
    template.find("input").val("");
    template.find("select").val("PASSPORT");

    if (count < currentTravelersCount) {
      // remove
      travelers.find(".traveler").slice(count).remove();
    } else if (count > currentTravelersCount) {
      // add
      for (let i = currentTravelersCount; i < count; i++) {
        const newTraveler = template.clone();
        travelers.append(newTraveler);
      }
    }

    reIndexTravelers(travelers);
  };

  const fillVerificationData = () => {
    // travel policy data
    const trip_type = travelCalculationForm
      .find("select[name=trip_type]")
      .val();
    const trip_type_text = travelCalculationForm
      .find("select[name=trip_type] option:selected")
      .text();
    const multi_trip_type_text = travelCalculationForm
      .find("select[name=multi_trip_type] option:selected")
      .text();
    const travel_purpose_text = travelCalculationForm
      .find("select[name=travel_purpose] option:selected")
      .text();
    const start_date = travelCalculationForm
        .find("input[name=start_date]")
        .val(),
      start_date_text = start_date + " 00:00";
    const end_date = travelCalculationForm.find("input[name=end_date]").val(),
      end_date_text = end_date + " 23:59";
    const coverage_area_text = travelCalculationForm
      .find("select[name=coverage_area] option:selected")
      .text();
    const covid_coverage_text = travelCalculationForm
      .find("select[name=covid_coverage] option:selected")
      .text();
    const insurance_amount_text = travelCalculationForm
      .find("select[name=insurance_amount] option:selected")
      .text();
    const currency_text = travelCalculationForm
      .find("select[name=currency] option:selected")
      .text();

    if (trip_type === "ONE_TRIP") {
      $("input#v_end_date").val(end_date_text);
    } else {
      $("input#v_multi_trip_type").val(multi_trip_type_text);
    }
    $("input#v_trip_type").val(trip_type_text);
    $("input#v_travel_purpose").val(travel_purpose_text);
    $("input#v_start_date").val(start_date_text);
    $("input#v_coverage_area").val(coverage_area_text);
    $("input#v_covid_coverage").val(covid_coverage_text);
    $("input#v_insurance_amount").val(insurance_amount_text);
    $("input#v_currency").val(currency_text);

    // insured person data
    let insured_person_name = travelInsuredPersonForm
      .find("input[name=insured_person_name]")
      .val();
    const insured_person_surname = travelInsuredPersonForm
      .find("input[name=insured_person_surname]")
      .val();
    const insured_person_father_name = travelInsuredPersonForm
      .find("input[name=insured_person_father_name]")
      .val();
    const insured_person_type = travelInsuredPersonForm
      .find("select[name=insured_person_type]")
      .val();

    if (insured_person_type === "P") {
      insured_person_name = `${insured_person_name} ${insured_person_surname} ${insured_person_father_name}`;
    }

    const insured_person_pin = travelInsuredPersonForm
      .find("input[name=insured_person_pin]")
      .val();
    const insured_person_tin = travelInsuredPersonForm
      .find("input[name=insured_person_tin]")
      .val();
    const insured_person_phone_number = travelInsuredPersonForm
      .find("input[name=insured_person_phone_number]")
      .val();
    const insured_person_email = travelInsuredPersonForm
      .find("input[name=insured_person_email]")
      .val();

    $("input#v_insured_person_pin").val(insured_person_pin);
    $("input#v_insured_person_tin").val(insured_person_tin);
    $("input#v_insured_person_email").val(insured_person_email);
    $("input#v_insured_person_phone").val(insured_person_phone_number);
    $("input#v_insured_person_name").val(insured_person_name);

    // travelers data
    const travelers = $(".travelers .traveler");
    const v_travelers = $(".v_travelers");
    const v_traveler_template = v_travelers.find(".v_traveler").first().clone();
    v_travelers.empty();

    for (let i = 0; i < travelers.length; i++) {
      const traveler = $(travelers[i]);
      const traveler_document_type = traveler
        .find("select[name*=traveler_document_type]")
        .val();

      let traveler_name,
        traveler_surname,
        traveler_passport_id = "";

      const v_traveler = v_traveler_template.clone();
      if (traveler_document_type === "PASSPORT") {
        traveler_passport_id = traveler
          .find(`input[name=traveler-${i}-traveler_passport_id]`)
          .val();
        traveler_name = traveler
          .find(`input[name=traveler-${i}-traveler_name_on_passport]`)
          .val();
        traveler_surname = traveler
          .find(`input[name=traveler-${i}-traveler_surname_on_passport]`)
          .val();
        v_traveler.find(".vPassportField").show();
      } else {
        traveler_passport_id = "";
        traveler_name = traveler
          .find(`input[name=traveler-${i}-traveler_name]`)
          .val();
        traveler_surname = traveler
          .find(`input[name=traveler-${i}-traveler_surname]`)
          .val();
        v_traveler.find(".vPassportField").hide();
      }
      const traveler_pin = traveler
        .find(`input[name=traveler-${i}-traveler_pin]`)
        .val();
      const traveler_birth_date = traveler
        .find(`input[name=traveler-${i}-traveler_birth_date]`)
        .val();

      v_traveler
        .find("input.v_traveler_name")
        .val(`${traveler_name} ${traveler_surname}`);
      v_traveler.find("input.v_traveler_pin").val(traveler_pin);
      v_traveler.find("input.v_traveler_passport").val(traveler_passport_id);
      v_traveler.find("input.v_traveler_birth_date").val(traveler_birth_date);
      v_travelers.append(v_traveler);
    }

    // extra coverages data
    const checkedExtraCoverages = [];
    travelCalculationForm
      .find("input[name=extra_coverages]")
      .each((_, input) => {
        if ($(input).prop("checked")) {
          checkedExtraCoverages.push(
            $(input).parent().find("label").text().trim(),
          );
        }
      });

    const vExtraCoverages = $(".v_extra_coverages");
    if (checkedExtraCoverages.length) {
      vExtraCoverages.show();
      vExtraCoverages.find("ul").empty();
      vExtraCoverages
        .find("ul")
        .append(
          checkedExtraCoverages
            .map((coverage) => `<li>${coverage}</li>`)
            .join(""),
        );
    } else {
      vExtraCoverages.hide();
    }
  };

  travelTravelersForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "validate_travelers",
    });
    form.loading({
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then(() => {
        travelVerifyDataForm.loading({ action: "hide" });
        fillVerificationData();
        toggleBetweenElements(travelTravelersForm, travelVerifyDataForm);
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          400,
        );
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  travelVerifyDataForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = [];
    data.push(...travelCalculationForm.serializeArray());
    data.push(...travelInsuredPersonForm.serializeArray());
    data.push(...travelTravelersForm.serializeArray());
    data.push(...travelVerifyDataForm.serializeArray());
    data.push({
      name: "action",
      value: "create_policy",
    });
    form.loading({
      action: "show",
      loadingText: getJsContext("creation_loading_text"),
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        window.location.href = response["redirect_url"];
        setTravelStepperStep(4);
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          400,
        );
      })
      .catch((errors) => {
        const error_in = errors["error_in"];
        delete errors["error_in"];
        if (error_in === "calculation_form") {
          setTravelStepperStep(1);
          toggleBetweenElements(
            travelVerifyDataForm,
            travelCalculationForm,
            500,
            () => {
              ajaxErrorAlert(errors, travelCalculationForm);
            },
          );
        } else if (error_in === "insured_person_form") {
          setTravelStepperStep(2);
          toggleBetweenElements(
            travelVerifyDataForm,
            travelInsuredPersonForm,
            500,
            () => {
              ajaxErrorAlert(errors, travelInsuredPersonForm);
            },
          );
        } else if (error_in === "travelers_form") {
          setTravelStepperStep(3);
          toggleBetweenElements(
            travelVerifyDataForm,
            travelTravelersForm,
            500,
            () => {
              ajaxErrorAlert(errors, travelTravelersForm);
            },
          );
        } else if (error_in === "verify_data_form") {
          ajaxErrorAlert(errors, travelVerifyDataForm);
        } else {
          setTravelStepperStep(1);
          toggleBetweenElements(
            travelVerifyDataForm,
            travelCalculationForm,
            500,
            () => {
              ajaxErrorAlert(errors, travelCalculationForm);
            },
          );
        }
      });
  });

  travelPaymentForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    form.loading({
      action: "show",
      loadingText: getJsContext("please_wait") + "...",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", { action: "get_payment_url_from_wims_payment" }, form)
      .then((response) => {
        form.loading({
          action: "show",
          loadingText: getJsContext("redirecting") + "...",
          extraClasses: "spinner-fixed",
        });
        window.top.location.href = response["redirect_url"];
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  if (checkPaymentForm.length) {
    ajaxPost("", { action: "check_payment" }, checkPaymentForm)
      .then((response) => {
        window.location.href = response["redirect_url"];
      })
      .catch((errors) => {
        $("#pageFirstLoading").remove();
        ajaxErrorAlert(errors, checkPaymentForm);
      });
  }

  $("select[name=insured_person_type]").on("change", function (e) {
    const input = $(e.target);
    const insuredPersonType = input.val();
    const insuredPersonTypePhysicalFields = $(
      ".insuredPersonTypePhysicalField",
    );
    const insuredPersonTypeLegalFields = $(".insuredPersonTypeLegalField");

    if (insuredPersonType === "L") {
      insuredPersonTypePhysicalFields.hide();
      insuredPersonTypePhysicalFields
        .find("input, select")
        .removeAttr("required");
      insuredPersonTypeLegalFields.show();
      insuredPersonTypeLegalFields
        .find("input, select")
        .attr("required", "required");
      travelInsuredPersonForm.find(".insuredPersonAlsoTravelerField").hide();
    } else {
      insuredPersonTypePhysicalFields.show();
      insuredPersonTypePhysicalFields
        .find("input, select")
        .attr("required", "required");
      insuredPersonTypeLegalFields.hide();
      insuredPersonTypeLegalFields.find("input, select").removeAttr("required");
      travelInsuredPersonForm.find(".insuredPersonAlsoTravelerField").show();
    }
  });

  $(document).on("change", "select.traveler_document_type", function (e) {
    const input = $(e.target);
    const parent = input.closest(".traveler");
    const travelerDocumentType = input.val();

    const travelerDocumentTypePassportFields = parent.find(
      ".travelerDocumentTypePassportField",
    );
    const travelerDocumentTypeIDFields = parent.find(
      ".travelerDocumentTypeIDField",
    );

    if (travelerDocumentType === "ID") {
      travelerDocumentTypePassportFields.hide();
      travelerDocumentTypePassportFields
        .find("input, select")
        .removeAttr("required");
      travelerDocumentTypeIDFields.show();
      travelerDocumentTypeIDFields
        .find("input, select")
        .attr("required", "required");
    } else {
      travelerDocumentTypePassportFields.show();
      travelerDocumentTypePassportFields
        .find("input, select")
        .attr("required", "required");
      travelerDocumentTypeIDFields.hide();
      travelerDocumentTypeIDFields.find("input, select").removeAttr("required");
    }
  });

  $("#backToCalculationForm").on("click", (e) => {
    e.preventDefault();
    const calculationForm = $("#travelCalculationForm");
    const travelInsuredPersonForm = $("#travelInsuredPersonForm");
    toggleBetweenElements(travelInsuredPersonForm, calculationForm);
    setTravelStepperStep(1);
  });

  $("#backToInsuredPersonForm").on("click", (e) => {
    e.preventDefault();
    const travelInsuredPersonForm = $("#travelInsuredPersonForm");
    const travelTravelersForm = $("#travelTravelersForm");
    toggleBetweenElements(travelTravelersForm, travelInsuredPersonForm);

    setTravelStepperStep(2);
  });

  $("#backToTravelersForm").on("click", (e) => {
    e.preventDefault();
    const travelTravelersForm = $("#travelTravelersForm");
    const travelVerifyDataForm = $("#travelVerifyDataForm");
    toggleBetweenElements(travelVerifyDataForm, travelTravelersForm);
  });

  $(".downloadTravelPolicy").on("click", (e) => {
    const button = $(e.currentTarget);
    const policyNumber = button.data("policy-number");

    const data = {
      action: "get_policy_pdf",
      policy_number: policyNumber,
    };

    travelPolicyForm.loading({
      action: "show",
      loadingText: getJsContext("preparing") + "...",
    });

    ajaxPost("", data, travelPolicyForm)
      .then((response) => {
        travelPolicyForm.loading({
          action: "show",
          loadingText: getJsContext("loading") + "...",
        });
        const data = `data:${response["content_type"]};base64,${response["base64"]}`;
        const link = document.createElement("a");
        link.href = data;
        link.download = String(response["file_name"]);
        link.click();
        setTimeout(() => {
          travelPolicyForm.loading({ action: "hide" });
        }, 1500);
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, travelPolicyForm);
      });
  });

  $(".sendTravelPolicy").on("click", (e) => {
    const button = $(e.currentTarget);
    const policyNumber = button.data("policy-number");

    const data = {
      action: "send_email_modal",
      policy_number: policyNumber,
    };

    const modal = bsModal("medium", {
      title: getJsContext("send_policy_to_email"),
      modalId: "sendTravelPolicyModal",
      backdrop: "none",
      keyboard: true,
    });

    ajaxPost("", data)
      .then((response) => {
        $(modal).modal("content", response["html"]);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors),
        }).then(() => {
          $(modal).modal("hide");
        });
      });
  });

  $(document).on("submit", "#sendTravelPolicyEmailForm", (e) => {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({ name: "action", value: "send_email" });
    form.loading({ action: "show" });
    ajaxPost("", data, form)
      .then(() => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          form.closest(".modal").modal("hide");
        });
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  $(".downloadPaymentReceipt").on("click", (e) => {
    const button = $(e.currentTarget);
    const paymentId = button.data("payment-id");

    const data = {
      action: "get_payment_receipt_pdf",
      payment_id: paymentId,
    };

    travelPolicyForm.loading({
      action: "show",
      loadingText: getJsContext("preparing") + "...",
    });

    ajaxPost("", data, travelPolicyForm)
      .then((response) => {
        travelPolicyForm.loading({
          action: "show",
          loadingText: getJsContext("loading") + "...",
        });
        const data = `data:${response["content_type"]};base64,${response["base64"]}`;
        const link = document.createElement("a");
        link.href = data;
        link.download = String(response["file_name"]);
        link.click();
        setTimeout(() => {
          travelPolicyForm.loading({ action: "hide" });
        }, 1500);
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, travelPolicyForm);
      });
  });

  if (travelPolicyForm.length) {
    ajaxPost("", { action: "send_all_email" }, travelPolicyForm)
      .then((response) => {
        if (response["success"] && response["message"]) {
          bsToast({
            content: response["message"],
          });
        }
      })
      .catch((errors) => {
        console.log("All emails not sent", errors);
      });
  }

  const referralForm = $("#referralForm");
  if (referralForm.length) {
    referralForm.on("submit", (e) => {
      e.preventDefault();
      const form = $(e.target);
      const data = form.serializeArray();
      data.push({ name: "action", value: "get_travel_creation_url" });
      ajaxPost("", data, form)
        .then((response) => {
          window.location.href = response["redirect_url"];
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
          $("#pageFirstLoading").remove();
        });
    });
    referralForm.trigger("submit");
  }
}
